import * as React from 'react';
import { Text, Modal, TextButton, MessageBoxFunctionalLayout } from 'wix-style-react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { DataHooks } from '@src/constants/data-hooks';
import { withBIModalEvents, ModalProps } from '@src/components/with-bi-modal-events/with-bi-modal-events';
import { PopupType } from '@src/context/actions/bi';

type Props = ModalProps & InjectedTranslateProps & { isOpen: boolean; supportKBLink: string };
const FailedPromptComponent = translate()(({ t, isOpen, onCancel, onClose, onOk, supportKBLink }: Props) => (
  <Modal dataHook={DataHooks.SaveFailedModal} isOpen={isOpen} onRequestClose={onClose} shouldCloseOnOverlayClick>
    <MessageBoxFunctionalLayout
      dataHook={DataHooks.SaveFailedPrompt}
      confirmText={t('save.and.publish.fail.retry')}
      onOk={onOk}
      cancelText={t('save.and.publish.fail.close')}
      onCancel={onCancel}
      onClose={onClose}
      title={t('save.and.publish.fail.title')}
      width="600px"
      theme="red"
    >
      <Text>
        {t('save.and.publish.fail.message-1')}
        <TextButton onClick={() => window.open(supportKBLink, '_blank')}>
          {t('save.and.publish.fail.message-2')}
        </TextButton>
        {t('save.and.publish.fail.message-3')}
      </Text>
    </MessageBoxFunctionalLayout>
  </Modal>
));

export const FailedPrompt = withBIModalEvents(PopupType.SomethingsWrong)(FailedPromptComponent);
